import React, { useEffect, useState } from "react";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  Button,
} from "reactstrap";
// Formik validation
import { useFormik } from "formik";

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useHistory, useParams } from "react-router-dom";
import ResultHandler from "../../../../components/ResultHandler";
import { editPool, getPool } from "../../../../api/pools";
import FormButtonHandler from "../../../../components/FormButtonHandler";
import { useResponse } from "../../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import { useGetInstence } from "../../../../hooks/useGetInstence";

import FIELDS from "./CONSTANT";
import PoolForm from "./PoolForm";
import * as Yup from "yup";

const TYPES = {
  select: null,
  "add-more": [],
  checkbox: false,
};

const initialValues = {};
const FIELDS_VALIDATION = {};

FIELDS.forEach((f) => {
  initialValues[f.key] = TYPES[f.type] ? TYPES[f.type] : "";
  if (f.type == "file") {
    FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
      "This Field Is Required"
    );
  } else if(f.type != 'select') {
    FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required");
  }
});

const EditPool = () => {
  let navigate = useHistory();

  const { t } = useTranslation();

  const params = useParams();

  const [editedPool, setEditedPool] = useState(null);
  const [contractId, setContractId] = useState(null);

  const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
    getPool,
    params.id,
    (response) => {
      setContractId(response.data.data.pool.companyContract?.id);
      setEditedPool({...response.data.data.pool, employees: response.data.data.pool.employees.map(e => e.id), employeesArr: response.data.data.pool.employees.map(e => ({id: e.id, name: e.name}))});
    }
  );

  const { setData, loading, error, success } = useResponse(editPool, () => {
    navigate.goBack();
  });

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      ...editedPool,
      company_contracts: contractId
    },
    validationSchema: Yup.object(FIELDS_VALIDATION),
    onSubmit: (values) => {
      let data = {
        ...values,
      };
      setData({ type: "edit", id: params.id, data });
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title={t("Pools")} breadcrumbItem={"Edit Pool"} />
          {editedPool && <div className="text-end mb-3">
            <Button size="" color="dark" onClick={() => navigate.push('/pool-hours/'+ params.id)}>Hours Collections</Button>  
          </div>}

          {editedPool && (
            <Form
              className="needs-validation"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <PoolForm validation={validation} />

              <FormButtonHandler btnTxt="Edit" loading={loading} />
            </Form>
          )}

          <ResultHandler
            loading={instenceLoading}
            error={error}
            success={success}
            successMsg={"Updated Successfully!"}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditPool;
